import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { mergeMap, map, withLatestFrom, filter } from 'rxjs/operators';
import * as DropdownActions from './dropdown.actions';
import { selectDropdownState } from './dropdown.selectors';
import { DropdownService } from '../../services/moduleServices/dropdown.service';



@Injectable()
export class DropdownEffects {
   loadDropdown$
  constructor(
    private readonly actions$: Actions,
    private readonly store: Store,
    private readonly dropdownService: DropdownService
  ) {
  this.loadDropdown$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DropdownActions.loadDropdown),

      withLatestFrom(this.store.select(selectDropdownState)),

      // Cache per scope
      filter(([action, state]) => {
           /**
         * Important:
         * This bypasses the cache.
         * Use it when you know the backend data may have changed.
         */
        if (action.forceReload) {
          return true;
        }
        const scopeState = state.scopes[action.scope];

        return action.keys.some(key => {
          if (!scopeState) return true;

          switch (key) {
            case 'COUNTRIES': return scopeState.countries.length === 0;
            case 'STATES':    return scopeState.states.length === 0;
            // case 'LGA':       return scopeState.lgas.length === 0;
           default: {
  const value = scopeState.common[key];
  return !Array.isArray(value) || value.length === 0;
}

          }
        });
      }),

      // Route to correct endpoint + dispatch success
      mergeMap(([action]) => {
        let request$;

        switch (action.scope) {
          case 'COMMON':
            request$ = this.dropdownService.getCommonDropdowns(action.keys);
            break;

          case 'POLICY_PLANS':
            request$ = this.dropdownService.getPolicyPlanDropdowns(action.keys);
            break;

          case 'POLICY_PACKAGES':
            request$ = this.dropdownService.getPolicyPackageDropdowns(action.keys);
            break;

            case 'POLICY_PROGRAMS':
            request$ = this.dropdownService.getPolicyProgramDropdowns(action.keys);
            break;

            case 'POLICY_TARIFFS':
            request$ = this.dropdownService.getPolicyTariffDropdowns(action.keys);
            break;

            case 'POLICY_SERVICES':
            request$ = this.dropdownService.getPolicyServiceDropdowns(action.keys);
            break;

            case 'POLICY_DRUGS':
            request$ = this.dropdownService.getPolicyDrugDropdowns(action.keys);
            break;

            case 'POLICY_CAPITATIONS':
            request$ = this.dropdownService.getPolicyCapitationDropdowns(action.keys);
            break;

            case 'POLICY_PREMIUMS':
            request$ = this.dropdownService.getPolicyPremiumDropdowns(action.keys);
            break;

            case 'NONAUTH':
            request$ = this.dropdownService.getNonAuthDropdowns(action.keys);
            break;

          default:
            return []; // important: never return undefined
        }

        return request$.pipe(
          map(res =>
            DropdownActions.loadDropdownSuccess({
              scope: action.scope,
              data: res
            })
          )
        );
      })
    )
  );

  }
}


